import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import SubBlockMenuData from './SubBlockMenuData';

class BlockMenuListData {
  title?: BlockComponentText;
  titleImage?: BlockComponentImage;
  backgroundImage?: BlockComponentImage;
  menus?: SubBlockMenuData[];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockMenuListData {
  export function make(
    title: string,
    titleImage: string,
    backgroundImage: string,
    menus: SubBlockMenuData[],
  ): BlockMenuListData {
    return {
      title: title ? BlockComponentText.make(title) : undefined,
      titleImage: BlockComponentImage.make(titleImage),
      backgroundImage: BlockComponentImage.make(backgroundImage),
      menus,
    };
  }

  export function getDefault(title = 'タイトル', titleImage = '', backgroundImage = ''): BlockMenuListData {
    return make(
      `<p><strong>${title}</strong></p>`,
      titleImage,
      backgroundImage,
      [
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
        SubBlockMenuData.getDefault(undefined, titleImage),
      ],
    );
  }
}

export default BlockMenuListData;
